import { Dashboard } from "@/model/data/dashboard/Dashboard";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";

export class FetchDashboardListResData extends ApiGenericResponse {
    dashboards: Dashboard[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            response.data.Payload.forEach((dashboarJson) => {
                var dashboard = new Dashboard();
                dashboard.fillFromJson(dashboarJson, null);
                this.dashboards.push(dashboard);
            });
        }
    }
}
